import classNames from "classnames";
import React from "react";
import { twMerge } from "tailwind-merge";
import useComponentRef from "../../hooks/useComponentRef";
import Button from "../Button";
import Label from "../Label";
import MarkdownText from "../MarkdownText/MarkdownText";
import Textarea from "../Textarea";
import Tooltip from "../Tooltip/Tooltip";
import { Icon } from "../Icon/Icon";
const MarkdownTextArea = React.forwardRef(({ id, label, value, onChange, onlyLinks, className, textareaClassName, typography, errorText, isError, disablePreview, disabled, required, previewMode, onPreviewModeChange, placeholder, dataCySuffix, }, outerRef) => {
    const [_isPreviewMode, setIsPreviewMode] = React.useState(false);
    const componentRef = useComponentRef(outerRef);
    const isPreviewMode = previewMode ?? _isPreviewMode;
    const dataCy = dataCySuffix
        ? `ukt-markdown-textarea-${dataCySuffix}`
        : "ukt-markdown-textarea";
    const _inputId = React.useId();
    const inputId = id ?? _inputId;
    return (React.createElement("div", { className: twMerge("flex flex-col gap-1", className) },
        React.createElement("div", { className: "flex w-full items-center" },
            React.createElement(Label, { htmlFor: inputId, required: required, className: "!mb-0 " }, label),
            React.createElement(Tooltip, { alignment: "bottomRight", portalAnchor: "bottomLeft", content: onlyLinks ? (React.createElement("div", null,
                    React.createElement("strong", { className: "typography-label whitespace-nowrap" },
                        "This field supports Markdown Links ",
                        React.createElement("br", null)),
                    React.createElement("span", { className: "typography-small__t mt-[3px]" }, "e.g. you can use the following syntax:"),
                    React.createElement("ul", { className: "ml-4 list-disc" },
                        React.createElement("li", null, "[Link Name](https://funjoin.com)")))) : (React.createElement("div", { className: "typography-small__t flex w-[334px] flex-col " },
                    React.createElement("div", { className: "typography-label flex items-center gap-2 text-gray-text-color" },
                        React.createElement(Icon, { className: "markdown-icon bg-icon-grey-color" }),
                        "Markdown Customization"),
                    React.createElement("div", { className: "mt-1" },
                        "Use Markdown for more styling options wherever you see the Markdown icon:",
                        React.createElement("ul", { className: "ml-4 list-disc" },
                            React.createElement("li", null, "### Heading Level 3"),
                            React.createElement("li", null, "**bold text**"),
                            React.createElement("li", null, "*italicize text*"),
                            React.createElement("li", null, "[Link Name](https://funjoin.com)"))),
                    React.createElement("div", { className: "typography-small__t mt-[2px]" },
                        "For a full guide, visit\u00A0",
                        React.createElement("a", { href: "https://www.markdownguide.org/basic-syntax/", target: "_blank", rel: "noreferrer", className: "hover:cursor-pointer" }, "this page")))) },
                React.createElement("div", { className: "pr-0.5" },
                    React.createElement(Icon, { className: classNames(onlyLinks ? "policy-links-icon" : "markdown-icon", "ml-[6px] ") }))),
            !disablePreview && (React.createElement(Button, { disabled: disabled, onClick: () => {
                    setIsPreviewMode(!isPreviewMode);
                    onPreviewModeChange?.(!isPreviewMode);
                    setTimeout(() => {
                        componentRef.current?.focus();
                    });
                }, className: "ml-auto", kind: "text" },
                isPreviewMode ? (React.createElement(Icon, { className: "edit-icon icon-lg" })) : (React.createElement(Icon, { className: "password-icon icon-lg" })),
                isPreviewMode ? "Edit" : "Preview"))),
        React.createElement("div", { style: {
                minHeight: componentRef.current
                    ? componentRef.current?.scrollHeight + 2
                    : "auto",
            }, className: twMerge("rounded-[10px]  border-[1px] border-solid border-transparent px-[16px] py-[10px]", !isPreviewMode && "hidden") },
            React.createElement(MarkdownText, { onlyLinks: onlyLinks, className: twMerge("text-text-color", typography ?? "typography-main") }, value)),
        React.createElement(Textarea, { id: inputId, placeholder: placeholder, disabled: disabled, isError: isError, className: classNames(isPreviewMode && "!hidden"), errorText: errorText, ref: componentRef, textareaClassName: twMerge(textareaClassName, typography ?? "typography_main"), value: value, onChange: onChange, autoExpandable: true, "data-cy": dataCy })));
});
export default MarkdownTextArea;
//# sourceMappingURL=MarkdownTextArea.js.map